import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './AboutUs.module.css';

gsap.registerPlugin(ScrollTrigger);


// Placeholder images (tương tự ảnh bạn upload)
const banchanImg = "https://thumbs.dreamstime.com/b/close-up-shot-showcases-various-korean-banchan-including-kimchi-rice-seasoned-vegetables-arranged-bowls-wooden-397213627.jpg";
 const AboutUsComponent = (props) => {
     const {handleClick} = props
     const containerRef = useRef(null);

     useEffect(() => {
         const ctx = gsap.context(() => {
             gsap.fromTo(
                 `.${styles.section}`,
                 { opacity: 0, y: 100 },
                 {
                     opacity: 1,
                     y: 0,
                     duration: 1.2,
                     stagger: 0.4,
                     ease: "power3.out",
                 }
             );

             gsap.fromTo(
                 `.${styles.title}`,
                 { opacity: 0, y: 30 },
                 { opacity: 1, y: 0, duration: 1, delay: 0.5, stagger: 0.3 }
             );

             gsap.fromTo(
                 `.${styles.text}`,
                 { opacity: 0 },
                 { opacity: 1, duration: 1.2, delay: 0.8 }
             );

             gsap.fromTo(
                 `.${styles.btn}`,
                 { scale: 0.9, opacity: 0 },
                 { scale: 1, opacity: 1, duration: 0.8, delay: 1.2 }
             );
         }, containerRef);

         return () => ctx.revert();
     }, []);

     return (
         <div className={styles.container} ref={containerRef} >
             {/* Section Mission */}
             <section className={`${styles.section} ${styles.missionSection}`}>
                 <div className={styles.textWrapper}>
                     <div className={styles.smallTitle}>Giri Restaurant - Asian Fusion Cuisine</div>
                     <div className={styles.title}>Unsere Mission</div>
                     <div className={styles.text}>
                        Unsere Mission ist es, die feine Kunst der Asian Fusion Cuisine nach Dresden zu bringen –
                        in einen Raum, in dem kulinarische Traditionen Asiens und zeitgenössische Raffinesse zu einer harmonischen Einheit verschmelzen.
                        Wir schaffen einen Ort der Begegnung, an dem vielschichtige Aromen, ästhetische Klarheit und aufrichtige Gastfreundschaft zusammenkommen – für Momente des bewussten Genusses und der Ruhe.
                        Mit höchstem Anspruch und größter Sorgfalt wählen wir ausschließlich erstklassige Zutaten, frische Meeresfrüchte und saisonales Gemüse aus. Die Verbindung authentischer asiatischer Esskulturen mit handwerklicher Präzision und moderner Kreativität bildet die Grundlage unserer Küche.
                        So entsteht eine kulinarische Handschrift, die elegant, fein ausbalanciert und emotional berührend ist.
                        Wir freuen uns darauf, Sie in Dresden willkommen zu heißen –
                        zu einer exklusiven kulinarischen Reise durch die Welt der Asian Fusion Cuisine.
                    </div>
                     <button onClick={handleClick} className={styles.btn}>Tisch reservieren</button>
                 </div>

                 <div className={styles.imageWrapper}>
                     <img src={"assets/imgs/foods/img-giri (13).jpg"} alt="Authentische japanische Gerichte" className={styles.roundImage} />
                 </div>
             </section>

             {/* Section Vision / Über Uns */}
             <section className={`${styles.section} ${styles.aboutSection}`}>
                 <div className={styles.textWrapper}>
                     <div className={styles.smallTitle}>Giri Restaurant - Asian Fusion Cuisine</div>
                     <div className={styles.title}>Über Uns</div>
                     <div className={styles.text}>
                        Die Geschichte von GIRI
                        GIRI steht für Haltung, Respekt und ästhetischen Anspruch.
                        Inspiriert von asiatischen Genusskulturen verbinden wir Tradition und moderne Kreativität zu einer zeitgemäßen Asian Fusion Cuisine.
                        Unsere Küche lebt von Balance, Klarheit und handwerklicher Präzision – ergänzt durch eine Atmosphäre, in der bewusster Genuss und aufrichtige Gastfreundschaft im Mittelpunkt stehen.
                        GIRI ist mehr als ein Restaurant:
                        Es ist ein Ort, an dem Kulinarik zelebriert wird und Momente entstehen, die bleiben.
                    </div>
                     <button onClick={handleClick} className={styles.btn}>Tisch reservieren</button>
                 </div>

                 <div className={styles.imageWrapper}>
                     <img
                         src="assets/imgs/home/home (7).jpg"
                         alt="Japanischer Koch am Teppanyaki-Grill"
                         className={styles.roundImage}
                     />
                 </div>
             </section>
         </div>
     );
}

export default AboutUsComponent;